module.exports = __webpack_public_path__ + "static/media/desirability.f5692fbf.png";